const translations = {
  en: {
    // Globals
    ticket: 'Ticket',
    tickets: 'Tickets',
    'In Support Of:': 'In Support Of:',
    for: 'for',
    ticketPackages: 'Ticket Packages',
    'Continue to payment': 'Continue to payment',
    'Your Cart': 'Your Cart',
    'First Name': 'First Name',
    'Last Name': 'Last Name',
    'Additional Names': 'Additional Names',
    'Gift Ticket': 'Is this a group purchase or gifted ticket?',
    'Gift Name': 'Enter the names you wish to appear on the ticket(s).',
    Disclaimer:
      'Disclaimer: All tickets issued will contain the same information. Ticket packages cannot be individualized.',
    Address: 'Address',
    City: 'City',
    Province: 'Province',
    'Postal Code': 'Postal Code',
    'Phone Number': 'Phone Number',
    'Email Address': 'Email Address',
    'Confirm Email Address': 'Confirm Email Address',
    'Payment Information': 'Payment Information',
    'Card Number': 'Card Number',
    'Expiry Date': 'Expiry Date',
    'How did you hear?': 'How did you hear?',
    CVC: 'CVC',
    Purchase: 'Purchase',
    LDHCaslConfirmation:
      'I confirm that the information provided is accurate, and acknowledge that my personal information will be collected in accordance with Rafflebox Technologies {termsOfUse}.',
    'CASL Confirmation':
      'I confirm that the information provided is accurate, and acknowledge that my personal information will be collected in accordance with Rafflebox Technologies {privacyPolicy} and {termsOfUse}.',
    onlineSalesDisabled: 'Online sales are disabled for this event.',
    Success: {
      thankYou: 'Thank you,',
      inTheDraw: 'You are now in the draw',
      messagePrepend: 'Your ticket numbers were sent to',
      message: "and should arrive within the next 15 minutes. If they don't appear, check your spam/junk folder.",
      saveYourTickets: 'Save your tickets',
      manageYourTickets: 'Manage your tickets',
      manageYourRafflesMessage: 'Download your tickets as a PDF or manage all of your orders by becoming a Player.',
      downloadTicketsAltMessage: 'Download your tickets as a PDF by clicking on the button below',
      weAreGeneratingTickets: 'We are generating your unique tickets for the draw',
      pleaseWait: 'This may take up to a minute',
      yourPurchase: 'Your Purchase',
      total: 'Total',
      'Your details': 'Your details',
      'Back to draw': 'Back to draw',
      'Create Online Order': 'Create Online Order',
      returnToLiveRaffles: 'Return to live raffles page',
      success: 'Success',
      downloadTicketsMessage: 'You can choose to download your tickets as a PDF by clicking on the button below.',
      becomePlayer: 'Create an Account',
      downloadTickets: 'Download Tickets',
      forgetSomething: 'Forget something',
      forgetSomethingMessage:
        'If they do not appear, check your spam/junk folder, or you can download a PDF of the tickets.',
      thisPageHasExpired: 'This page has expired',
      orderConfirmationExpirationMessage:
        'Order confirmations are only saved for seven days. After this time, they are no longer available for download.',
      'Additional Names': 'Additional Names',
      previewTickets: 'View Tickets',
      previewTicketsMessage: 'Save your tickets! View your tickets by clicking on the button below.',
      loggedInMessage: 'View your tickets now by logging into your Player Portal account.',
      subscriptionHeader: 'You’re Subscribed!',
      subscriptionMessage:
        'Your subscription to future raffles is now active. We’ll automatically place your ticket order for each new raffle using your selected order and saved payment method. You’ll get a confirmation email with each purchase, and you can cancel anytime from the link in those emails.'
    },
    Payment: {
      billingAddress: 'Billing Address',
      emailHint: 'We will send you a confirmation email for your purchase',
      provinceHint: 'You must live in the province of the raffle',
      postalHint: 'Postal code must match what is registered with your Credit Card company',
      additionalHint: 'Enter the names you wish to appear on the ticket(s).',
      payWithExistingCard: '****{last4} expires {expMonth}/{expYear}',
      membership: {
        header: 'Membership',
        content:
          'Looking after Loyal Supporters like YOU … become a Member and Never Miss Out on Any Draws!<br/><br/>Today your credit card will be charged for only the current order you select. Should you choose to sign up for Membership, this order will be saved, ensuring you tickets for future Dream Lotteries … you will never miss out on any draws!<br/><br/>Dream Lottery will be in contact with you prior to the launch of the next Dream Lottery to confirm your order and charge your credit card.',
        checkbox1: 'I wish to sign up for a membership',
        checkbox1Disclaimer:
          'Membership Terms & Conditions: Dream Lottery will be in contact with you prior to the launch of the next Dream Lottery to confirm your order prior your credit card being charged in case you would like to amend your membership order. If you would like to make any changes to your membership order or to cancel your membership order, you can do so anytime by contact us at 1-866-319-9818 or customerservice@dreamitwinit.ca (Monday to Friday from 9:00 a.m. – 5:00 p.m.). In the event you do not look to cancel or amend your membership order, your membership order as outlined and selected above will be processed with your tickets being emailed to you within 3-4 business days after your credit card is charged.',
        checkbox2: 'No thanks',
        privacyPolicy:
          'I confirm that the information provided is accurate, and acknowledge that my personal information will be collected in accordance with Rafflebox Technologies {privacyPolicy} and {termsOfUse}.',
        LDHPrivacyPolicy:
          'This event is administered by the London Health Sciences Foundation and this information is protected and governed by the privacy policies of the London Health Sciences Foundation. Any personal information that you provide is collected for the purpose of fulfilling this Lottery, promoting future such lotteries and other fundraising activities. The Foundation does not rent, sell, or trade our mailing lists. For our full privacy statement call 1-866-440-9868 or visit {contactUs}'
      },
      subscription: {
        header: 'Subscribe to this Raffle!',
        content:
          'Love playing? Stay in the action automatically! By checking this box, you’re subscribing to this reoccurring raffle with your selected purchase using the payment method provided. We’ll place your order each time a new raffle goes live. You can cancel anytime.',
        checkbox1: 'Yes, subscribe me to this raffle',
        checkbox1Disclaimer:
          'By subscribing, you understand that your payment method will be automatically charged when the next raffle goes live. You’ll receive an email confirmation each time your order is processed.'
      }
    },
    CartContents: {
      orderSummary: 'Order Summary',
      order: 'Order #:'
    },
    AgeCheckMessages: {
      generic: 'I am {age} years or older.',
      Alberta: 'I am {age} years or older and a resident of Alberta.',
      'British Columbia': 'I am {age} years or older and a resident of British Columbia.',
      Manitoba: 'I am {age} years or older and accept the rules.',
      'New Brunswick': 'I am {age} years or older and a resident of New Brunswick.',
      'Newfoundland and Labrador': 'I am {age} years or older and a resident of Newfoundland and Labrador.',
      'Northwest Territories': 'I am {age} years or older and a resident of Northwest Territories.',
      'Nova Scotia': 'I am {age} years or older and a resident of Nova Scotia',
      Nunavut: 'I am {age} years or older and a resident of Nunavut.',
      Ontario: 'I am {age} years or older and accept the rules.',
      'Prince Edward Island': 'I am {age} years or older and a resident of Prince Edward Island.',
      Quebec: 'I am {age} years or older and a resident of Québec.',
      Saskatchewan: 'I am {age} years or older and a resident of Saskatchewan.',
      Yukon: 'I am {age} years or older and a resident of Yukon.'
    },
    TermsAndPolicy: {
      prependMessage: 'By making a purchase, you agree to our',
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of Use'
    },

    //Replace once we get actual content
    ThresholdReached: {
      soldOut: 'Sold Out',
      joinWaitlist: 'Join the waitlist',
      content:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      contact: 'To join the waitlist please contact: (xxx)-xxx-xxx'
    }
  },
  fr: {
    // Globals
    ticket: 'Billet',
    tickets: 'billets',
    'In Support Of:': 'En appui à : ',
    for: 'pour',
    ticketPackages: 'Ensembles de billets',
    'Continue to payment': 'Passer au paiement',
    'Your Cart': 'Votre panier',
    'First Name': 'Prénom',
    'Last Name': 'Nom de famille',
    'Additional Names': 'Noms supplémentaires',
    'Gift Ticket': "S'agit-il d'un achat de groupe ou d'un billet offert en cadeau ?",
    'Gift Name': 'Veuillez entrer les noms que vous souhaitez voir apparaître sur le(s) billet(s).',
    Disclaimer:
      'Avis de non-responsabilité : Tous les billets émis contiendront les mêmes informations. Les forfaits de billets ne peuvent pas être personnalisés individuellement.',
    Address: 'Adresse',
    City: 'Ville',
    Province: 'Province',
    'Postal Code': 'Code postal',
    'Phone Number': 'Tél.',
    'Email Address': 'Adresse électronique',
    'Confirm Email Address': 'Confirmer l’adresse électronique',
    'Payment Information': 'Information de paiement',
    'Card Number': 'Numéro de carte',
    'Expiry Date': "Date d'expiration",
    'How did you hear?': 'Comment as-tu entendu ?',
    CVC: 'CVC',
    Purchase: 'Acheter pour',
    onlineSalesDisabled: 'Les ventes en ligne sont désactivées pour cet événement.',
    Success: {
      messagePrepend: 'Vos numéros de billets vous ont été envoyés à',
      message:
        "et devraient arriver dans les 15 prochaines minutes. S'ils n'apparaissent pas, veuillez vérifier votre dossier spam/courrier indésirable.",
      yourPurchase: 'Votre achat',
      thankYou: 'Merci',
      inTheDraw: 'Vous êtes maintenant dans le tirage au sort',
      saveYourTickets: 'Sauvegardez vos billets',
      manageYourTickets: 'Gérer vos billets',
      manageYourRafflesMessage:
        'Téléchargez vos billets au format PDF ou gérez toutes vos commandes en devenant joueur.',
      downloadTicketsAltMessage: 'Téléchargez vos billets au format PDF en cliquant sur le bouton ci-dessous',
      weAreGeneratingTickets: 'Nous générons vos billets uniques pour le tirage',
      pleaseWait: "Cela peut prendre jusqu'à une minute",
      total: 'Total',
      'Your details': 'Vos détails',
      'Back to draw': 'Retourner au tirage',
      'Create Online Order': 'Créer une commande en ligne',
      returnToLiveRaffles: 'Retourner à la page des tirages actifs',
      success: 'Réussite',
      downloadTicketsMessage:
        'Vous pouvez choisir de télécharger une version PDF de vos billets en cliquant sur le buton ci-dessous.',
      becomePlayer: 'Créez un compte',
      downloadTickets: ' Télécharger des billets',
      forgetSomething: 'Vous avez oublié quelque chose',
      forgetSomethingMessage: `S'ils ne vous parviennent pas, vérifiez votre dossier de pourriels ou dossier poubelle, ou vous pouvez télécharger une version PDF des billets.`,
      thisPageHasExpired: 'Cette page a expiré',
      orderConfirmationExpirationMessage:
        'Les confirmations de commande ne sont conservées que 7 jours. Après cette période, elles ne sont plus disponibles pour télécharger.',
      'Additional Names': 'Noms supplémentaires',
      previewTickets: 'Voir les billets',
      previewTicketsMessage: 'Sauvegardez vos billets! Voir vos billets en cliquant sur le bouton ci-dessous.',
      loggedInMessage: 'Consultez vos billets dès maintenant en vous connectant à votre compte Portail Joueur.',
      subscriptionHeader: 'Vous êtes abonné!',
      subscriptionMessage:
        'Votre abonnement aux tirages futurs est maintenant actif. Nous passerons automatiquement votre commande de billets pour chaque nouveau tirage en utilisant votre commande sélectionnée et votre mode de paiement enregistré. Vous recevrez un courriel de confirmation pour chaque achat, et vous pouvez annuler à tout moment à partir du lien dans ces courriels.'
    },
    Payment: {
      billingAddress: 'Adresse de facturation',
      emailHint: 'Nous vous enverrons un courriel confirmant votre achat.',
      provinceHint: 'Vous devez vivre dans la province du tirage.',
      postalHint: 'Le code postal doit correspondre à l’information que possède votre compagnie de carte de crédit.',
      additionalHint: 'Saisissez les noms que vous souhaitez voir apparaître sur le(s) billet(s).',
      payWithExistingCard: '****{last4} expire le {expMonth}/{expYear}',
      subscription: {
        header: 'Abonnement',
        checkbox1: 'Je souhaite m’inscrire à un abonnement',
        checkbox1Disclaimer:
          'Je comprends qu’en cochant cette case, j’accepte un abonnement avec des frais récurrents de {amount} CAD/mois. J’autorise {organization} à facturer mon mode de paiement chaque mois jusqu’à ce que je l’annule.'
      }
    },
    CartContents: {
      orderSummary: 'Résumé de la commande',
      order: 'Votre n° de commande : '
    },
    AgeCheckMessages: {
      generic: "J'ai {age} ans ou plus.",
      Alberta: "J'ai {age} ans ou plus et je suis résident de l'Alberta.",
      'British Columbia': "J'ai {age} ans ou plus et je suis résident de la Colombie-Britannique.",
      Manitoba: "J'ai {age} ans ou plus et j'accepte les règles.",
      'New Brunswick': "J'ai {age} ans ou plus et je suis résident du Nouveau-Brunswick.",
      'Newfoundland and Labrador': 'Je suis âgé de {age} ans ou plus et je réside à Terre-Neuve-et-Labrador.',
      'Northwest Territories': 'Je suis âgé de {age} ans ou plus et je réside dans les Territoires du Nord-Ouest.',
      'Nova Scotia': "J'ai {age} ans ou plus et je suis résident de la Nouvelle-Écosse",
      Nunavut: "J'ai {age} ans ou plus et je suis résident du Nunavut.",
      Ontario: "J'ai {age} ans ou plus et j'accepte les règles.",
      'Prince Edward Island': "Je suis âgé de {age} ans ou plus et je réside sur l'Île-du-Prince-Édouard.",
      Quebec: "J'ai {age} ans ou plus et je réside au Québec.",
      Saskatchewan: "J'ai {age} ans ou plus et je suis résident de la Saskatchewan.",
      Yukon: "J'ai {age} ans ou plus et je réside au Yukon."
    },
    TermsAndPolicy: {
      prependMessage: 'Le fait de cliquer sur Achat indique que vous acceptez les dispositions de la',
      privacyPolicy: 'déclaration de confidentialité',
      termsOfUse: "conditions d'utilisation"
    },
    'CASL Confirmation': `Je confirme que les informations fournies sont excates, et je reconnais que mes informations personnelles seront collectées conformement á la {privacyPolicy} et aux {termsOfUse} de Rafflebox Technologies.`,

    //Replace w french once we know the actual content
    ThresholdReached: {
      soldOut: 'Épuisé',
      joinWaitlist: 'Join the waitlist',
      content:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      contact: 'To join the waitlist please contact: (xxx)-xxx-xxx'
    }
  }
};

export default translations;
